// Hero signup form: real native POST (this store's customer/contact
// endpoint needs a CAPTCHA token that only exists on a genuine submit),
// targeted at a hidden same-page iframe so the page never navigates.
// On submit we slide a dismissible confirmation toast in from the left,
// aligned with the top of the hero heading. It (and any manual close)
// auto-dismisses after ~2.5s and clears the signup field so the form is
// ready to use again. The form markup itself is never touched.
//
// The same toast also doubles as a confirmation for the separate
// Email Opt-In page (/pages/email-opt-in), whose form is a third-party
// Shopify Forms app embed we don't control. That form's own "redirect
// after submission" setting points back here with ?signup=success in
// the URL; on load we detect that, swap the toast's text to the
// redirect-specific copy, show it, and strip the param so a refresh
// doesn't re-trigger it.
(function () {
  if (window.location.hash === '#CustomHeroForm') {
    history.replaceState(null, '', window.location.pathname + window.location.search);
  }

  var AUTO_DISMISS_MS = 2500;
  var REDIRECT_AUTO_DISMISS_MS = 4000;

  function resetForm(form) {
    if (!form) return;
    try { form.reset(); } catch (e) {}
    var email = form.querySelector('input[type="email"]');
    if (email) email.value = '';
  }

  function dismiss(toast, form) {
    if (!toast || toast.hidden) return;
    if (toast._autoTimer) { clearTimeout(toast._autoTimer); toast._autoTimer = null; }
    toast.classList.add('custom-hero__toast--dismissing');
    var done = function () {
      toast.hidden = true;
      toast.classList.remove('custom-hero__toast--dismissing');
      resetForm(form);
    };
    var t = setTimeout(done, 600);
    toast.addEventListener('transitionend', function h() {
      clearTimeout(t); done(); toast.removeEventListener('transitionend', h);
    });
  }

  function show(toast, form, autoDismissMs) {
    if (!toast) return;
    toast.classList.remove('custom-hero__toast--dismissing');
    toast.hidden = false;
    if (toast._autoTimer) clearTimeout(toast._autoTimer);
    toast._autoTimer = setTimeout(function () {
      dismiss(toast, form);
    }, autoDismissMs || AUTO_DISMISS_MS);
  }

  function init() {
    var form = document.querySelector('.js-custom-hero-form');
    var scope = (form && form.closest('.custom-hero-section')) || document;
    var toast = scope.querySelector('.js-custom-hero-toast');
    var toastText = scope.querySelector('.js-custom-hero-toast-text');
    var closeBtn = scope.querySelector('.js-custom-hero-toast-close');

    if (closeBtn && toast) {
      closeBtn.addEventListener('click', function () { dismiss(toast, form); });
    }

    // No-JS fallback path: Liquid already rendered the toast visible after
    // a full-page submit. Arm its auto-dismiss + reset timer.
    if (toast && !toast.hidden) show(toast, form);

    // Redirect-from-opt-in-page path: a ?signup=success in the URL means
    // the visitor just submitted the Forms app embed on /pages/email-opt-in
    // and got redirected back here. Swap in that copy, show the toast,
    // then clean the URL.
    if (toast) {
      var params = new URLSearchParams(window.location.search);
      if (params.get('signup') === 'success') {
        if (toastText && toast.dataset.redirectText) {
          toastText.textContent = toast.dataset.redirectText;
        }
        show(toast, null, REDIRECT_AUTO_DISMISS_MS);

        params.delete('signup');
        var query = params.toString();
        var cleanUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
        history.replaceState(null, '', cleanUrl);

        // If the toast gets dismissed (manually or automatically) after
        // being shown for the redirect case, restore the normal signup
        // copy so a later real form submit shows the right text again.
        if (toastText && toast.dataset.signupText) {
          toast.addEventListener('transitionend', function restore() {
            toastText.textContent = toast.dataset.signupText;
            toast.removeEventListener('transitionend', restore);
          });
        }
      }
    }

    if (!form || !toast) return;

    var sink = scope.querySelector('.js-custom-hero-sink');
    var sinkName = sink && sink.getAttribute('name');
    if (sinkName) form.setAttribute('target', sinkName);

    form.addEventListener('submit', function () {
      if (toastText && toast.dataset.signupText) {
        toastText.textContent = toast.dataset.signupText;
      }
      show(toast, form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
